export default __webpack_public_path__ + "static/media/black-hat-model.c827b4ab.jpg";